const SmartContrast = () => {
  return (
    <svg
      width="96"
      height="96"
      viewBox="0 0 96 96"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.105469"
        width="95.0004"
        height="95.0004"
        rx="47.5002"
        transform="rotate(0.0638669 0.105469 0)"
      />
      <path
        d="M79.0222 47.7571C79.012 56.9887 74.9834 65.3366 68.5715 71.0129C63.0395 76.0308 55.7199 79.037 47.6814 79.0281C30.4114 79.0088 16.3912 64.9573 16.4104 47.6873C16.4297 30.4172 30.4812 16.397 47.7512 16.4162C55.7897 16.4252 63.1025 19.4478 68.6233 24.478C75.0226 30.1685 79.0325 38.5254 79.0222 47.7571Z"
        stroke="black"
        strokeWidth="5.65205"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.6098 61.507C47.5412 66.6878 43.6777 67.9394 40.0685 66.491C32.6302 63.4998 27.3947 56.2094 27.4042 47.7003C27.4137 39.1912 32.6654 31.9124 40.1104 28.9064C43.7229 27.4661 47.5835 28.7578 47.6406 33.9073L47.6098 61.507Z"
        stroke="black"
        strokeWidth="5.65205"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmartContrast;
